var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0"},[(_vm.label)?_c('v-row',[_c('b',[_vm._v(_vm._s(this.label))])]):_vm._e(),(_vm.text)?_c('v-row',[_c('p',{class:['mb-0 v-input--description', {
      'v-input--description--next': _vm.isDescriptionLabel()
    }],attrs:{"full-width":""},domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }